export default "__VITE_ASSET__d5bea1a4__"